import React from "react";
import { Button, Flex, Typography } from "antd";
import { useNavigate } from 'react-router-dom';

const PageNotFoundComponent = () => {
    const { Text } = Typography;
    const navigate = useNavigate();

    const goHome = () => {
        navigate(`${process.env.REACT_APP_PREFIX}/`);
    }

    return (
        <Flex vertical style={{flex:1, width: '100%',padding:20,justifyContent:'center',alignItems:'center',alignSelf:'center', alignItems:'center',minHeight:'90vh',gap:30}}>
            <img src="http404.png" width="35%"/>           
            <Button size="large" color="red" variant="filled"  onClick={goHome}>Go to Home Page</Button>
        </Flex>
    )
}

export default PageNotFoundComponent;

